import React from 'react';
import { Route } from 'react-router-dom';
import BuyerIndexRoutes from './buyerIndex';

const Routes = [
  <Route key="buyer/*" path="buyer/*" element={<BuyerIndexRoutes />} />,
];

export default Routes;
